module.exports = __webpack_public_path__ + "media/images/flags/32/Netherlands-Antilles-d928c6e1953b749823d550d4d115b29b.png";